<template>
  <section id="page-charts">
    <div id="charts">
      <b-card>
        <b-row>
          <b-col>
            <b-button-toolbar>
              <b-button-group size="md">
                <b-button @click="setCurrent('line')" :variant="buttonVariant('line')">Linee</b-button>
                <b-button @click="setCurrent('column')" :variant="buttonVariant('column')">Barre</b-button>
              </b-button-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button-toolbar>
              <b-input-group  size="sm" prepend="Campionamento">
                <b-form-select v-model="sampling" :options="samplingValues"></b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mx-1" prepend="Periodo">
                <div class="form-control">
                  <div v-if="['1', '15', '60', 'd', 'w'].includes(sampling)">
                    <date-pick v-model="fromDate"
                               :isDateDisabled="isDateDisabled"
                               :inputAttributes="{ readonly: true }"
                               :months="monthsNames"
                               :weekdays="daysNames"
                               :selectableYearRange="5"
                               :maxSelectableYear="currentYear"
                               :format="'DD/MM/YYYY'" />
                    -
                    <date-pick v-model="toDate"
                               :inputAttributes="{readonly: true}"
                               :months="monthsNames"
                               :weekdays="daysNames"
                               :selectableYearRange="5"
                               :maxSelectableYear="currentYear"
                               :format="'DD/MM/YYYY'" />
                  </div>
                  <div v-if="sampling == 'm'">
                    <vue-monthly-picker v-model="fromMonth"
                                        :monthLabels="monthLabels"
                                        :max="maxMonth"
                                        dateFormat="MM/YYYY" />
                    -
                    <vue-monthly-picker v-model="toMonth"
                                        :monthLabels="monthLabels"
                                        dateFormat="MM/YYYY" />
                  </div>
                  <div v-if="sampling == 'y'" class="p-0">
                    <b-input-group size="sm" class="input-group-year">
                      <b-form-select v-model="fromYear" :options="yearOptions" class="mr-3"></b-form-select>
                      -
                      <b-form-select v-model="toYear" :options="yearOptions" class="ml-3"></b-form-select>
                    </b-input-group>
                  </div>
                </div>
              </b-input-group>
              <b-input-group size="sm" class="mx-1" prepend="Confronta" v-if="showCompare">
                <b-select v-model="compare">
                  <option value="no">--</option>
                  <option v-if="sampling != 'w'" value="previous">Periodo precedente</option>
                  <option v-if="sampling != 'w'" value="year">Anno precedente</option>
                  <option value="custom">Personalizzato</option>
                </b-select>
              </b-input-group>
              <b-input-group v-if="compare=='custom' && (current=='line' || current=='column')" size="sm" class="mx-1" prepend="Dal">
                <div class="form-control">
                  <div v-if="['15', '60', 'd', 'w'].includes(sampling)">
                    <date-pick v-model="compareFromDate"
                               :isDateDisabled="isFutureDate && isWeekAndIsNotMonday"
                               :inputAttributes="{ readonly: true }"
                               :months="monthsNames"
                               :weekdays="daysNames"
                               :format="'DD/MM/YYYY'" />
                  </div>
                  <div v-if="sampling == 'm'">
                    <vue-monthly-picker v-model="compareFromMonth"
                                        :monthLabels="monthLabels"
                                        dateFormat="MM/YYYY" />
                  </div>
                </div>
              </b-input-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div>
              <b-alert variant="warning" :show="showWarning">Nessuna sorgente selezionata</b-alert>

              <div class="channel-filters" v-if="selectedSources.length > 0">

                <template v-for="(source, index) in selectedSources">
                  <VBadge 
                    v-if="source.type === 'indicator'"
                    badgeType="indicators"
                    :key="index"
                    :source="source"
                    @remove="removeSource(source)"
                  />
                  <b-badge v-if="source.type === 'parameter'" :key="index" class="mb-4">
                  {{ source.name }}
                  <font-awesome-icon style="color:white;" @click="removeSource(source)" icon="times" />
                  <!-- <a class="remove-item-link" @click="removeParameter(parameter)">x</a> -->
                  </b-badge>
                </template>
                <b-badge variant="warning" v-if="selectedSources.length > 0" class="remove-all" @click="clearAllSelectedSources">Rimuovi tutti <a>x</a></b-badge>
              </div>
            </div>

            <line-chart ref="lineChartRef" :reportpopupMode="reportMode" v-if="current=='line'" :filter="filter"></line-chart>
            <line-chart ref="lineChartRef" :reportpopupMode="reportMode" v-if="current=='column'" type="bar" :filter="filter"></line-chart>

          </b-col>
        </b-row>
      </b-card>
    </div>
  </section>
</template>

<script>
import PageMixin from "./PageMixin";
import { mapState, mapActions } from 'vuex';
import VBadge from "./VBadge";

var moment = require('moment');

export default {
  components: {
    VBadge,
  },
  props: {
    reportMode:{
      required: false,
      default: false,
    },
    reportSection: {
      required: false,
      default: null
    }
  },

  mixins: [PageMixin],

  data() {
    return {
      mode: 'INDICATORS',
      fromDate: moment().subtract(1, 'months').format('DD/MM/YYYY'),
      toDate: moment().format('DD/MM/YYYY'),
      fromMonth: moment().subtract(1, 'months'),
      toMonth: moment(),
      fromYear: moment().subtract(1, 'years').format('yyyy'),
      toYear: moment().format('yyyy'),
    };
  },

  computed: {
    ...mapState({
      selectedSources: state => state.charts.selectedSources,
      // selectedChannels: state => state.charts.selectedIndicatorChannels,
      // selectedParameters: state => state.charts.selectedIndicatorParameters,
    }),
    yearOptions() {
      const yearOptions = [];
      for (let i = 2016; i <= parseInt(moment().format('yyyy').toString()); i++) {
        yearOptions.push({ text: i, value: moment(i.toString()).format('yyyy') });
      }
      return yearOptions;
    }
  },
}
</script>

<style>
.input-group-year {
  margin: -5px -27px 0 -6px;
}
.btn-toolbar .input-group .input-group-prepend .input-group-text {
  color: #1A1919;
  background: #7E827F;
}
.apexcharts-zoom-out-icon {
  margin-right: 30px;
}
.channel-filters span.badge {
  margin-right: 6px;
}
.channel-filters span.badge a {
  color: #ccc;
  text-decoration: none;
  position: relative;
  top: -4px;
}
.vdpPositionTop.vdpPositionLeft {
  z-index: 1000;
}
.channel-filters span.badge.remove-all {
  cursor: pointer;
}
.channel-filters span.badge.remove-all a {
  color: #333;
}
.channel-filters .remove-item-link {
  cursor: pointer;
}

.channel-filters {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/Charts/Indicators.vue